import { createFileRoute, Outlet } from '@tanstack/react-router'
import AdminGuard from '../components/AdminGuard'
import { AdminSidebar } from '../components/admin/AdminSidebar'

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <AdminGuard>
      <div className="flex h-screen bg-[#f9f8fb]">
        <AdminSidebar />
        <main className="flex-1 overflow-auto">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </AdminGuard>
  )
}
